import React from 'react';
import { iconSizer } from "../../../../../icons2022/iconSizer";
import { MarkupIcon24Regular } from "../../../../../icons2022/FileTypeMarkupIcon/MarkupIcon24Regular";
import { MarkupIcon32Regular } from "../../../../../icons2022/FileTypeMarkupIcon/MarkupIcon32Regular";
import { MarkupIcon64Regular } from "../../../../../icons2022/FileTypeMarkupIcon/MarkupIcon64Regular";
export var MarkupIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(MarkupIcon24Regular, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(MarkupIcon32Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(MarkupIcon64Regular, null);
  }
}, 'MarkupIcon');